import { femaleQuestionMedium, maleQuestionMedium, bulbMedium } from '@/assets/icons';
import {
  ALWAYS_DO_WHAT_ALWAYS_DID,
  ALWAYS_DO_WHAT_ALWAYS_DID_SOURCE,
  FIND_FAULT,
  FIND_FAULT_SOURCE,
} from './quotes';

const NO_BLAME = `
<div class="ia-sensei-quote">
  <span class="quote">"${FIND_FAULT}"</span>
  <br>
  <span class="author">${FIND_FAULT_SOURCE}</span>
</div>
<h2 class="basic-sub-title">
  Concentrez-vous sur le processus, pas sur les personnes
</h2>
<p>
  C'est humain, on veut savoir qui a mal fait les choses. Mais c'est la source d'une mauvaise relation entre manager et collaborateurs.<br>
  L'être humain évite d'être humilié parce que c'est l'une de ses plus grandes craintes ;
  donc si on sait que l'on risque de se voir reprocher d'avoir commis une erreur,
  on tente de le cacher et c'est un comportement normal.
</p>
<div class="ia-sensei-question">
  <div class="question-decoration"></div>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="${femaleQuestionMedium}"></path></svg>
  <span class="question">Si je ne lui fais pas remarquer qu'il a mal agi, il ne s'améliorera jamais...</span>
</div>
<p>
  Et c'est bien là une erreur classique.
</p>
<div class="ia-sensei-example">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="${bulbMedium}"></path></svg>
  <div class="example-title">Prenons l'exemple suivant :</div>
  Michael a commis une erreur de débutant en manipulant son chariot :
  Bien sûr, tout le monde sait que sur la "voie R", on est censé faire rouler les chariots en marche arrière.
  Sinon, ils risquent de se retrouver bloqués en fin de voie parce que les roues arrière ne peuvent pas tourner.<br>
  Ainsi, Michael, qui avait oublié cela, est maintenant coincé dans une position très inconfortable car il ne peut pas
  faire marche arrière et il est obligé de demander à ses collègues de l'aider à vider son chariot et le sortir de la voie en le portant...
</div>
<br>
<p>
  Bien sûr, aller dire à Michael ce qu'il a mal fait l'aidera à comprendre comment le faire correctement.<br>
  Mais cessons de nous concentrer sur qui a fait l'erreur et concentrons-nous sur <strong>ce qui s'est passé</strong> :
</p>
<br>
<div class="ia-sensei-example">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="${bulbMedium}"></path></svg>
  Un nouvel employé a fait une erreur car il n'y avait aucune indication sur la bonne façon de faire rouler un chariot sur la voie.
</div>
<div class="ia-sensei-question">
  <div class="question-decoration"></div>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="${maleQuestionMedium}"></path></svg>
  <span class="question">Mmmh ça n'a pas l'air trop compliqué à résoudre, on pourrait mettre un panneau d'indication à l'entrée de la voie R ?</span>
</div>
<p>
  Absolument. Et il ne sera même pas nécessaire d'aller voir Michael pour lui dire à quel point il a dérapé.<br>
  Au contraire, Michael pourrait être responsable de la résolution de ce problème.
  Maintenant, au lieu de se sentir coupable, il comprendra qu'on se soucie de lui et
  il apportera une amélioration à l'ensemble de ses collègues.<br>
  En conclusion, apprenez à voir <strong>ce qui s'est passé</strong> et arrêtez de chercher <strong>qui a mal agi</strong>.
</p>
<h2 class="basic-sub-title">
  Mettre en avant le comportement souhaité et montrer l'exemple
</h2>
<p>
  Un environnement "sans pointer du doigt" n'est pas facile à mettre en place et c'est plus un défi culturel qu'autre chose.
  Mais vous ne pouvez pas attendre des autres qu'ils fassent le premier pas. Commencez à vous intéresser aux processus
  plutôt qu'aux personnes, faites des suggestions à voix haute, soyez honnête et mettez en avant les personnes qui le font comme vous.<br>
  Si vous pensez que ce type d'environnement nécessite un changement culturel, vous ne pouvez y parvenir qu'en vous
  encourageant les uns les autres, en vous soutenant mutuellement et en montrant comment on prend ses responsabilités.
</p>
<div class="ia-sensei-quote">
  <span class="quote">"${ALWAYS_DO_WHAT_ALWAYS_DID}"</span>
  <br>
  <span class="author">${ALWAYS_DO_WHAT_ALWAYS_DID_SOURCE}</span>
</div>
<p>
  C'est plus facile à dire qu'à faire. C'est pourquoi les managers et les chefs d'équipe doivent mettre en place les conditions
  adéquates pour que les gens puissent s'exprimer. Laissez à chacun un moment pour s'exprimer chaque semaine ; lors des tournées terrain,
  demandez à vos collègues comment ils se sentent ; lors de la résolution des problèmes, demandez aux gens comment ils veulent y participer.<br>
  En somme, créez un environnement au sein duquel les collègues se font confiance et s'entraident.
  C'est la voie vers un environnement "sans pointer du doigt".
</p>
`;

const NO_BLAME_TITLE = 'Ne pas pointer du doigt';

export default {
  NO_BLAME,
  NO_BLAME_TITLE,
};
